export default "__VITE_ASSET__D7yr2jjo__"